<template>
  <div class="w-100 d-lg-flex align-items-center justify-content-center">
    <b-img
      fluid
      :src="imgLogo"
      alt="logo axismedical"
    />
  </div>
</template>
<script>
import { 
  BImg, 
} from 'bootstrap-vue'
export default {
  components: {
    BImg,
  },
  data() {
    return {
      imgLogo: require('@/assets/images/logo/axismedical-logo.png'),
    }
  },
}
</script>
